module.exports = __webpack_public_path__ + "media/src/images/partners/tsu-256b9dfc6de07b5a8ef4d0dfdfc38941.jpg";